export default "__VITE_ASSET__D805sMZT__"